import CoreSelect from '@/components/Form/SelectAntForm';
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import GetListBusinessDomainViewModel from '../viewmodels/business-domain-list.viewmodel';

interface Props {
  className?: string;
}

export const BusinessDomainPicker = (props: Props) => {
  const { className } = props;
  const { control } = useFormContext();
  const { businessDomainData, actionGetListBusinessDomain } = GetListBusinessDomainViewModel();

  useEffect(() => {
    actionGetListBusinessDomain();
  }, []);

  return (
    <CoreSelect
      control={control}
      name='businessDomainId'
      label='Business Domain'
      required
      showSearch
      optionsProps={businessDomainData ?? []}
      displayField='name'
      valueField='id'
      className={className}
      filterOption={(inputValue, option) => {
        if (option) {
          return String(get(option, 'label')).toLowerCase().includes(inputValue.toLowerCase());
        }
        return true;
      }}
    />
  );
};
